// ユーザー設定（localStorage に保存）

export interface UserSettings {
  accentHue: number      // oklch 色相 0〜360（デフォルト: 258）
  density: 'normal' | 'dense'  // カード密度
  sidebarCollapsed: boolean
}

const DEFAULTS: UserSettings = {
  accentHue: 258,
  density: 'normal',
  sidebarCollapsed: false,
}

const KEY = 'ml_settings'

export function loadSettings(): UserSettings {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return { ...DEFAULTS }
    return { ...DEFAULTS, ...JSON.parse(raw) }
  } catch {
    return { ...DEFAULTS }
  }
}

export function saveSettings(s: Partial<UserSettings>): void {
  try {
    const current = loadSettings()
    localStorage.setItem(KEY, JSON.stringify({ ...current, ...s }))
  } catch { /* ignore */ }
}

// CSS カスタムプロパティとして色相を適用
export function applyAccentHue(hue: number): void {
  document.documentElement.style.setProperty('--ml-accent-hue', String(hue))
}
